import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTelegramComponent } from './simple-icons-telegram.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTelegramComponent ],
    exports:      [ SimpleIconsTelegramComponent ],
    bootstrap:    []
})
export class SimpleIconsTelegramModule {}
